export default "__VITE_ASSET__B1y5pGe2__"